<div [formGroup]="form" fxLayout="column" fxLayoutGap="8px">
	<mat-form-field>
		<input
			matInput
			readonly
			(click)="startDatePicker.open()"
			formControlName="startDate"
			[matDatepicker]="startDatePicker"
			placeholder="Start Date"
		/>
		<mat-datepicker-toggle
			matSuffix
			[for]="startDatePicker"
		></mat-datepicker-toggle>
		<mat-datepicker #startDatePicker></mat-datepicker>
		<mat-hint *ngIf="!form.get('startDate').value"
			>Date cannot be before today.</mat-hint
		>
		<mat-error *ngIf="form.get('startDate').hasError('required')"
			>This field is required.</mat-error
		>
		<mat-error *ngIf="form.get('startDate').hasError('valueBeforeToday')"
			>Date cannot be before today.</mat-error
		>
	</mat-form-field>
	<mat-form-field>
		<input
			matInput
			readonly
			(click)="endDatePicker.open()"
			formControlName="endDate"
			[matDatepicker]="endDatePicker"
			placeholder="End Date"
		/>
		<mat-datepicker-toggle
			matSuffix
			[for]="endDatePicker"
		></mat-datepicker-toggle>
		<mat-datepicker #endDatePicker></mat-datepicker>
		<mat-hint *ngIf="!form.get('endDate').value"
			>Date cannot be before today.</mat-hint
		>
		<mat-error *ngIf="form.get('endDate').hasError('required')"
			>This field is required.</mat-error
		>
		<mat-error *ngIf="form.get('endDate').hasError('valueBeforeToday')"
			>Date cannot be before today.</mat-error
		>
	</mat-form-field>
	<mat-form-field>
		<textarea
			autocomplete="reason"
			rows="2"
			matInput
			placeholder="Reason"
			formControlName="reason"
		>
		</textarea>
	</mat-form-field>
</div>
